import { useState } from "react";
import "@/App.css";
import { TopBar } from "./components/TopBar";
import { PhotoModal } from "./components/PhotoModal";
import { ContactModal } from "./components/ContactModal";
import { Hero } from "./sections/Hero";
import { PeopleSection } from "./sections/PeopleSection";
import { GritBand } from "./sections/GritBand";
import { RealEstateSection } from "./sections/RealEstateSection";
import { ContactSection } from "./sections/ContactSection";
import { SiteFooter } from "./sections/SiteFooter";

export default function App() {
  const [activeCategory, setActiveCategory] = useState(null);
  const [contactOpen, setContactOpen] = useState(false);

  const openContact = () => setContactOpen(true);

  return (
    <div id="top" className="min-h-screen bg-[#F4F1EA] text-[#2C3639]">
      <TopBar onContact={openContact} />

      <main>
        <Hero />
        <PeopleSection />
        <GritBand />
        <RealEstateSection onOpenCategory={setActiveCategory} />
        <ContactSection onContact={openContact} />
      </main>

      <SiteFooter />

      {activeCategory && (
        <PhotoModal
          category={activeCategory}
          onClose={() => setActiveCategory(null)}
        />
      )}

      {contactOpen && <ContactModal onClose={() => setContactOpen(false)} />}
    </div>
  );
}
